import React, { useState, forwardRef } from 'react';
import styled from 'styled-components';
import { Paper, Tabs, Tab, Button } from '@mui/material';
import PersonalInfoForm from './forms/PersonalInfoForm';
import EducationForm from './forms/EducationForm';
import ExperienceForm from './forms/ExperienceForm';
import SkillsForm from './forms/SkillsForm';
import ResumePreview from './ResumePreview';

const EditorContainer = styled.div`
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 2rem;
  padding: 2rem;
  // height: calc(100vh - 64px);
  // 添加y轴滚动条
  // overflow-y: auto;

  // 添加媒体查询以适应移动端
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
`;

const PreviewContainer = styled(Paper)`
  padding: 2rem;
  overflow-y: auto;

  // 在移动端增加一些样式调整
  @media (max-width: 768px) {
    margin-top: 1rem;
    overflow-y: visible;
  }
`;

const ResumeEditor = forwardRef(({ template, initialData, onSave }, ref) => {
  const [activeTab, setActiveTab] = useState(0);
  const [resumeData, setResumeData] = useState(initialData);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const updateResumeData = (section, data) => {
    setResumeData(prev => ({
      ...prev,
      [section]: data
    }));
  };

  const handleSave = () => {
    onSave(resumeData);
  };

  return (
    <EditorContainer >
      <Paper>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="个人信息" />
          <Tab label="教育经历" />
          <Tab label="工作经验" />
          <Tab label="技能特长" />
        </Tabs>
        
        {activeTab === 0 && (
          <PersonalInfoForm
            data={resumeData.personalInfo}
            onChange={data => updateResumeData('personalInfo', data)}
          />
        )}
        {activeTab === 1 && (
          <EducationForm
            data={resumeData.education}
            onChange={data => updateResumeData('education', data)}
          />
        )}
        {activeTab === 2 && (
          <ExperienceForm
            data={resumeData.experience}
            onChange={data => updateResumeData('experience', data)}
          />
        )}
        {activeTab === 3 && (
          <SkillsForm
            data={resumeData.skills}
            onChange={data => updateResumeData('skills', data)}
          />
        )}
        
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          style={{ margin: '1rem' }}
        >
          保存简历
        </Button>
      </Paper>

      <PreviewContainer >
      {template && <ResumePreview ref={ref} template={template} data={resumeData} />}
      </PreviewContainer>
    </EditorContainer>
  );
});

export default ResumeEditor; 